export default "__VITE_ASSET__DPm4ExZQ__"